import {useEffect} from 'react';
import {isUserPremium} from '@Libraries/user.library';
import {useAppSelector} from '@/hooks';
import {getPAYGUserCredits} from '@Components/payg-user-credits/payg-user-credits-library';
import type {PAYGUserCreditsProps} from '@Components/payg-user-credits/payg-user-credits-slice';

export function useGetPAYGUserCredits(): PAYGUserCreditsProps {
  const paygUserCredits = useAppSelector((state) => {
    return state.paygUserCredits;
  });

  useEffect((): void => {
    if (isUserPremium() || paygUserCredits.isLoading) {
      return;
    }

    if (paygUserCredits.isImageBGREnabled !== null && paygUserCredits.isVideoBGREnabled !== null) {
      return;
    }

    void getPAYGUserCredits();
  }, []);

  return paygUserCredits;
}
